import { withStyles } from '@material-ui/core';
import MainLayout from './MainLayout';
import styles from './styles';

export default withStyles(styles)(MainLayout);
